import React, { useEffect, useState, useRef } from 'react';
import api from '../../services/api';

const DocumentsUpload = ({ userId }) => {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [uploads, setUploads] = useState({});
  const [latest, setLatest] = useState({});
  const dateRefs = useRef({});

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data } = await api.get('/document-types');
        setTypes(Array.isArray(data) ? data : []);
        // načítaj aktuálny stav dokumentov pre používateľa kvôli zobrazeniu posledného nahratia
        try {
          const resp = await api.get(`/users/${userId}/documents`);
          const items = resp.data?.documents || [];
          const map = {};
          items.forEach(it => { if (it.uploaded_at || it.valid_to || it.download_url) map[it.type_code] = it; });
          setLatest(map);
        } catch (_) {}

      } catch (e) {
        setError(e.message || 'Chyba pri načítaní typov dokumentov');
      } finally {
        setLoading(false);
      }
    })();
  }, [userId]);

  const setFile = (code, file) => {
    setUploads(prev => ({ ...prev, [code]: { ...(prev[code]||{}), file } }));
    setTimeout(() => { if (dateRefs.current[code]) dateRefs.current[code].focus(); }, 0);
  };
  const setValidTo = (code, valid_to) => setUploads(prev => ({ ...prev, [code]: { ...(prev[code]||{}), valid_to } }));

  const upload = async (code) => {
    try {
      const d = uploads[code];
      if (!d?.file || !d?.valid_to) return alert('Vyberte súbor a nastavte platnosť (Platné do).');
      const fd = new FormData();
      fd.append('file', d.file);
      fd.append('valid_to', d.valid_to);
      await api.post(`/users/${userId}/documents/${code}`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      alert('Dokument nahratý');
      // refresh latest map for user
      try {
        const resp = await api.get(`/users/${userId}/documents`);
        const items = resp.data?.documents || [];
        const map = {};
        items.forEach(it => { if (it.uploaded_at || it.valid_to || it.download_url) map[it.type_code] = it; });
        setLatest(map);
      } catch(_) {}
      setUploads(prev => ({ ...prev, [code]: {} }));
      if (dateRefs.current[code]) dateRefs.current[code].value = '';
    } catch (e) {
      alert('Chyba: ' + (e.response?.data?.error || e.message));
    }
  };

  if (loading) return <div>Načítavam...</div>;
  if (error) return <div className="error">❌ {error}</div>;

  return (
    <div className="user-documents-upload">
      <table className="documents-table">
        <thead>
          <tr>
            <th>Dokument</th>
            <th>Vyber dokument</th>
            <th>Nastav platnosť</th>
            <th>Upload</th>
          </tr>
        </thead>
        <tbody>
          {types.map((t) => (
            <tr key={t.code}>
              <td style={{ fontWeight:600 }}>
                {(t.code === 'preukaz' || (t.name && t.name.toLowerCase().trim() === 'preukaz')) ? 'BSN' : t.name}
                {latest[t.code] && (
                  <div style={{fontWeight:400, fontSize:'12px', color:'#495057', marginTop:'4px'}}>
                    Posledný súbor: {latest[t.code].download_url ? (
                      <button onClick={() => (async ()=>{ try{ const url = latest[t.code].download_url ? latest[t.code].download_url.replace(/(^https?:\/\/[^/]+)?\/(api\/)?uploads\//, '/uploads/') : latest[t.code].download_url; if(!url) return; const res = await fetch(url, { credentials:'include' }); if(!res.ok) throw new Error(`HTTP ${res.status}`); const blob = await res.blob(); const a=document.createElement('a'); const obj=URL.createObjectURL(blob); a.href=obj; a.download=(t.name||'dokument'); document.body.appendChild(a); a.click(); document.body.removeChild(a); setTimeout(()=>URL.revokeObjectURL(obj),500);}catch(e){alert('Chyba pri sťahovaní: '+(e.message||'Neznáma chyba')); } })()} className="download-btn" style={{background:'none', border:'none', cursor:'pointer', padding:0}}>stiahnuť</button>
                    ) : '—'}
                    {latest[t.code].valid_to && (
                      <>
                        {' '}• Platnosť do: {new Date(latest[t.code].valid_to).toLocaleDateString('sk-SK')}
                      </>
                    )}
                  </div>
                )}
              </td>
              <td>
                <input
                  type="file"
                  accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  onChange={(e)=> setFile(t.code, e.target.files && e.target.files[0])}
                />
              </td>
              <td>
                <input
                  type="date"
                  required
                  ref={el => { dateRefs.current[t.code] = el; }}
                  onChange={(e)=> setValidTo(t.code, e.target.value)}
                />
              </td>
              <td>
                <button type="button" onClick={()=> upload(t.code)}>Nahrať</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DocumentsUpload;
